import { createQueryClient } from "@roncal/ui";

export const queryClient = createQueryClient();
